<template>
  <div class="form-group intensity-group">
    <span :class="(intensity == 'low' ? 'text-error' : 'none')">{{userform.intensity.low}}</span>
    <span :class="(intensity == 'mid' ? 'text-warning' : 'none')">{{userform.intensity.mid}}</span>
    <span :class="(intensity == 'high' ? 'text-success' : 'none')">{{userform.intensity.high}}</span>
  </div>
</template>
<script>
import { userform } from '../../locale'

export default {
  name: 'PasswordIntensity',
  props: ['password'],
  data() {
    return {
      userform
    }
  },
  computed: {
    intensity() {
      // 当用户放开键盘或密码输入框失去焦点时, 显示不同级别的颜色
      if (this.password == null || this.password == '') {
        return 'none'
      } else {
        var sLevel = this.checkStrong(this.password)
        switch (sLevel) {
          case 0:
            return 'none'
          case 1:
            return 'low'
          case 2:
            return 'mid'
          default:
            return 'high'
        }
      }
    }
  },
  methods: {
    checkStrong(sPW) {
      // 返回密码的强度级别
      if (sPW.length < 6 || sPW.length > 16) {
        return 0 // 超出长度范围
      }
      var Modes = 0
      for (var i = 0; i < sPW.length; i++) {
        // 测试每一个字符的类别并统计一共有多少种模式.
        Modes |= this.CharMode(sPW.charCodeAt(i))
      }
      return this.bitTotal(Modes)
    },
    CharMode(iN) {
      // 测试某个字符是属于哪一类.
      if (iN >= 48 && iN <= 57) { // 数字
        return 1
      }
      if (iN >= 65 && iN <= 90) { // 大写字母
        return 2
      }
      if (iN >= 97 && iN <= 122) { // 小写
        return 4
      } else {
        return 8 // 特殊字符
      }
    },
    bitTotal(num) {
      // 计算出当前密码当中一共有多少种模式
      var modes = 0
      for (var i = 0; i < 4; i++) {
        if (num & 1) {
          modes++
        }
        num >>>= 1
      }
      return modes
    }
  }
}

</script>
<style scoped lang="less">
.intensity-group {
  text-align: right;
  margin-top: -15px !important;
  margin-bottom: 0 !important;

  span {
    display: inline-block;
    width: 88px;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    color: #cdcdcd;
    background: none;
    border-width: 3px 0 0;
    border-style: solid;
    padding-bottom: 6px;

    &.intensity-none {
      border-color: #ccc;
    }

    &.intensity-low {
      border-color: #eb6878;
    }

    &.intensity-mid {
      border-color: #f7aa38;
    }

    &.intensity-high {
      border-color: #add597;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/login/PasswordIntensity.vue